module.exports = __webpack_public_path__ + "static/media/dan.c71dd442.png";